<button mat-raised-button id="{{name}}" [ngClass]="styleClass" [style.color]="color" (click)="btnClick()"
    [disabled]="disabled">
    <nuc-icon *ngIf="prefixIcon" iconClass="{{prefixIcon}}" color="{{iconColor}}" displayClass="icon-{{styleClass}}" size="{{size}}"></nuc-icon>
    <p class="button-text">{{text}}</p>
</button>